import setupMailDeeplinkCommonPostRender from './setupMailDeeplinkCommonPostRender';
import { lazyInitializeCalendarsDataForModule } from 'owa-calendar-bootstrap-utils';
import { initializeFeature } from 'owa-feature-flags';
import { lazyLoadLightningPrimaryView } from 'owa-lightning-view';
import { lazyModule as lazyMailFavoritesStore } from 'owa-mail-favorites-store';
import { initializeFocusedInboxConfig } from 'owa-mail-focused-inbox-config';
import { subscribeSaveFocusInboxOptionStitch } from 'owa-mail-focused-inbox-config';
import { lazyPrefetchFrequentlyUsedFolders } from 'owa-mail-folder-forest-actions';
import { lazySubscribeToInboxPlusRowNotifications } from 'owa-mail-inbox-plus-actions';
import { logInboxPlusExperimentData } from 'owa-mail-inbox-plus-store';
import { lazyReloadInboxPostBoot } from 'owa-mail-triage-table-load-extra';
import { subscribeSaveReadingPanePositionOptionStitch } from 'owa-mail-module-orchestrator';
import * as alwaysInCacheTableIdList from 'owa-mail-triage-local-updates/lib/actions/tableCache/alwaysInCacheTableIdList';
import { getMoveToMruList } from 'owa-mail-move-mru';
import { lazyModule as mailSearchLazyModule } from 'owa-mail-search';
import { lazyShowNotificationOnMailboxQuotaWarning } from 'owa-mail-triage-action';
import { lazyInitializeUpNextV2 } from 'owa-upnext-v2';
import { subscribeToNotifications } from 'owa-app-notifications-core';
import { lazyGovern } from 'owa-shared-post-boot';
import { isCacheFirstEnabled } from 'owa-readwrite-recipient-well/lib/actions/people/isCacheFirstEnabled';
import { lazyInitializeCache } from 'owa-recipient-cache';
import fetchCategoryDetailsAndSubscribeToCategoryNotifications from './helpers/fetchCategoryDetailsAndSubscribeToCategoryNotifications';
import { isInboxPlusEnabled, isInAnyInboxPlusExperiment } from 'owa-inbox-plus-util';

export default function setupMailModuleCommonPostRender(isFullApp?: boolean) {
    setupMailDeeplinkCommonPostRender(isFullApp);

    // important to minimize cover the delta between session data and subscription established
    lazyReloadInboxPostBoot.importAndExecute(alwaysInCacheTableIdList.getTableIdAtIndex(0));

    // don't govern stitches
    subscribeSaveFocusInboxOptionStitch();
    subscribeSaveReadingPanePositionOptionStitch();

    lazyGovern.importAndExecute(
        {
            condition: isCacheFirstEnabled(),
            task: () => lazyInitializeCache.importAndExecute(),
        },
        () => lazyMailFavoritesStore.import(),
        getMoveToMruList,
        () => mailSearchLazyModule.import(),
        subscribeToNotifications,
        {
            condition: isInboxPlusEnabled(),
            task: () => {
                lazySubscribeToInboxPlusRowNotifications
                    .import()
                    .then(subscribeToInboxPlusRowNotifications => {
                        subscribeToInboxPlusRowNotifications();
                    });
            },
        },
        () => lazyLoadLightningPrimaryView.importAndExecute(),
        () => fetchCategoryDetailsAndSubscribeToCategoryNotifications(),
        () => {
            initializeFeature('tri-upNextV2', () => {
                lazyInitializeUpNextV2.importAndExecute();
            });
        },
        () => lazyInitializeCalendarsDataForModule.importAndExecute(),
        {
            task: initializeFocusedInboxConfig,
            idle: isFullApp,
        },
        {
            task: () => lazyPrefetchFrequentlyUsedFolders.importAndExecute(),
            idle: isFullApp,
        },
        {
            task: () => lazyShowNotificationOnMailboxQuotaWarning.importAndExecute(),
            idle: isFullApp,
        },
        {
            condition: isInAnyInboxPlusExperiment(),
            task: logInboxPlusExperimentData,
            idle: isFullApp,
        }
    );
}
